export default __webpack_public_path__ + "static/gsclogo-inverse-d9d258a60f7140831c92fc8de80b4544.png";